import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  type CanActivate,
  Router,
  UrlTree,
} from '@angular/router';
import { CognitoService } from './cognito-service';

@Injectable()
export class AuthGuardService implements CanActivate {
  constructor(
    private router: Router,
    private cognitoService: CognitoService
  ) {}

  private getResolvedUrl(route: ActivatedRouteSnapshot): string {
    return route.pathFromRoot
      .map((v) => v.url.map((segment) => segment.toString()).join('/'))
      .join('/');
  }

  async canActivate(): Promise<boolean | UrlTree> {
    // Valid access token — nothing to do.
    if (this.cognitoService.userLoggedIn()) return true;

    // No session at all.
    if (localStorage.getItem('refresh_token') === null)
      return this.router.parseUrl('/authentication/login');

    // Expired access token but a refresh token is present. Block activation
    // until the refresh lands, otherwise the route renders against a stale
    // profile and the downstream role/feature guards bounce us to /dashboard.
    const refreshed = await this.cognitoService.refreshToken();
    if (!refreshed) return this.router.parseUrl('/authentication/login');

    return true;
  }
}
